import { Box } from "@mui/material";
import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { logEvent } from "@src/appV2/lib/analytics";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics/events";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { useHistory } from "react-router-dom";

import { EarlyAccessBanner } from "./EarlyAccessBanner";

interface EarlyAccessBannerContainerProps {
  sourceUI: "shifts-tab" | "account-tab";
  navigationPath: string;
}

export function EarlyAccessBannerContainer({
  sourceUI,
  navigationPath,
}: EarlyAccessBannerContainerProps) {
  const isEnabled = useCbhFlag(CbhFeatureFlag.EARLY_ACCESS_FACILITIES, { defaultValue: false });
  const history = useHistory();
  // Log when banner is shown
  useLogEffect(APP_V2_USER_EVENTS.EARLY_ACCESS_BANNER_SHOWN, { sourceUI }, { enabled: isEnabled });

  if (!isEnabled) {
    return null;
  }

  return (
    <Box>
      <EarlyAccessBanner
        onClick={() => {
          logEvent(APP_V2_USER_EVENTS.EARLY_ACCESS_BANNER_CTA_CLICKED, { sourceUI });
          history.push(navigationPath);
        }}
      />
    </Box>
  );
}
